module.exports = __webpack_public_path__ + "static/Roboto-Bold-57c12ad207f465f38a28c06b369ad2b8.woff";